import React, { Component } from "react";
import "../App.css";
import mindtree from "../images/mindtree.png";

class MindfullnessMain extends Component {
  render() {
    return (
      <>
        <section className="mindfullness-header categories-wrapper">
          <img src={mindtree} className="mindfullness-image category-image" />
          <div className="mindfullness-text">
            <h1>Achieve Mindfulness</h1>
            <p>
              Mindfulness is a type of meditation in which you focus on being
              intensely aware of what you're sensing and feeling in the moment,
              without interpretation or judgment.
            </p>
            <p>
              Practicing mindfulness involves breathing methods, guided imagery,
              and other practices to relax the body and mind and help reduce
              stress.
            </p>
          </div>
        </section>
      </>
    );
  }
}

export default MindfullnessMain;
